
import Clarity from '@microsoft/clarity';
import { useState } from "react";
import { Helmet } from "react-helmet";
import { CLARITY_PROJECT_ID } from '../../../project_config';
import Header from "../../common/header/Header";
import Form from "./form/Form";

export default function DiscussionAdd() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

	return (
		<>
			<Helmet>
				<title>افزودن گفتگو | همراهتیم</title>
				<meta name="description" content="افزودن گفتگو به همراهتیم" />
			</Helmet>

			<div className="bg-[#F0F6FC] min-h-screen">
				<Header isDesktop={isDesktop} />
				<div className="max-w-[600px] mx-auto p-[10px]">
					<div className="spacer p-[50px]"></div>
					<Form />
				</div>
				<div className="spacer p-[50px]"></div>
			</div>
		</>
	)
}
